type EligibilityDialogText = {
  heading: string
  subheading: string
  privacy_notice_heading: string
  privacy_notice_body: string
  question: string
  button_no: string
  button_yes: string
  verification_message: string
  verification_button: string
  verification_error_message: string
}

type ElibilityConfig = {
  name: string
  code: string
  eligibility_prompt_text: EligibilityDialogText
}
export const ELIGIBILITY_DIALOG_LANGUAGES: ElibilityConfig[] = [
  {
    name: 'English',
    code: 'en-US',
    eligibility_prompt_text: {
      heading: 'Check Insurance Eligibility',
      subheading: 'Takes 1 minute',
      privacy_notice_heading: 'Your information is only used for eligibility',
      privacy_notice_body: 'We do not store or share your data',
      question: 'Start?',
      button_no: 'No',
      button_yes: 'Yes',
      verification_message: 'Enter the Verification Code',
      verification_button: 'Continue',
      verification_error_message: 'Verification Code Is Required.',
    },
  },
  {
    name: 'Español',
    code: 'es-US',
    eligibility_prompt_text: {
      heading: 'Verificar Elegibilidad de Seguro',
      subheading: 'Toma 1 minuto',
      privacy_notice_heading: 'Su información solo se usa para elegibilidad',
      privacy_notice_body: 'No almacenamos ni compartimos sus datos',
      question: '¿Comenzar?',
      button_no: 'No',
      button_yes: 'Sí',
      verification_message: 'Ingrese el Código de Verificación',
      verification_button: 'Continuar',
      verification_error_message: 'Se requiere Código de Verificación.',
    },
  },
  {
    name: 'Deutsch',
    code: 'de-DE',
    eligibility_prompt_text: {
      heading: 'Versicherungsberechtigung prüfen',
      subheading: 'Dauert 1 Minute',
      privacy_notice_heading:
        'Ihre Informationen werden nur für die Berechtigung verwendet',
      privacy_notice_body: 'Wir speichern oder teilen Ihre Daten nicht',
      question: 'Starten?',
      button_no: 'Nein',
      button_yes: 'Ja',
      verification_message: 'Geben Sie den Verifizierungscode ein',
      verification_button: 'Weiter',
      verification_error_message: 'Verifizierungscode ist erforderlich.',
    },
  },
  {
    name: 'Français',
    code: 'fr-FR',
    eligibility_prompt_text: {
      heading: "Vérifier l'éligibilité à l'assurance",
      subheading: 'Prend 1 minute',
      privacy_notice_heading:
        "Vos informations sont utilisées uniquement pour l'éligibilité",
      privacy_notice_body: 'Nous ne stockons ni ne partageons vos données',
      question: 'Commencer?',
      button_no: 'Non',
      button_yes: 'Oui',
      verification_message: 'Entrez le code de vérification',
      verification_button: 'Continuer',
      verification_error_message: 'Le code de vérification est obligatoire.',
    },
  },
  {
    name: 'हिन्दी',
    code: 'hi-IN',
    eligibility_prompt_text: {
      heading: 'बीमा पात्रता जांचें',
      subheading: '1 मिनट लगता है',
      privacy_notice_heading:
        'आपकी जानकारी केवल पात्रता के लिए उपयोग की जाती है',
      privacy_notice_body: 'हम आपका डेटा संग्रहीत या साझा नहीं करते हैं',
      question: 'शुरू करें?',
      button_no: 'नहीं',
      button_yes: 'हाँ',
      verification_message: 'सत्यापन कोड दर्ज करें',
      verification_button: 'जारी रखें',
      verification_error_message: 'सत्यापन कोड आवश्यक है।',
    },
  },
  {
    name: 'Português',
    code: 'pt-BR',
    eligibility_prompt_text: {
      heading: 'Verificar Elegibilidade do Seguro',
      subheading: 'Leva 1 minuto',
      privacy_notice_heading:
        'Suas informações são usadas apenas para elegibilidade',
      privacy_notice_body: 'Não armazenamos ou compartilhamos seus dados',
      question: 'Começar?',
      button_no: 'Não',
      button_yes: 'Sim',
      verification_message: 'Digite o Código de Verificação',
      verification_button: 'Continuar',
      verification_error_message: 'Código de Verificação é obrigatório.',
    },
  },
  {
    name: 'العربية',
    code: 'ar-XA',
    eligibility_prompt_text: {
      heading: 'تحقق من أهلية التأمين',
      subheading: 'يستغرق دقيقة واحدة',
      privacy_notice_heading: 'يتم استخدام معلوماتك فقط للأهلية',
      privacy_notice_body: 'نحن لا نخزن أو نشارك بياناتك',
      question: 'ابدأ؟',
      button_no: 'لا',
      button_yes: 'نعم',
      verification_message: 'أدخل رمز التحقق',
      verification_button: 'استمر',
      verification_error_message: 'رمز التحقق مطلوب.',
    },
  },
  {
    name: 'Bahasa Indonesia',
    code: 'id-ID',
    eligibility_prompt_text: {
      heading: 'Periksa Kelayakan Asuransi',
      subheading: 'Memakan waktu 1 menit',
      privacy_notice_heading: 'Informasi Anda hanya digunakan untuk kelayakan',
      privacy_notice_body: 'Kami tidak menyimpan atau membagikan data Anda',
      question: 'Mulai?',
      button_no: 'Tidak',
      button_yes: 'Ya',
      verification_message: 'Masukkan Kode Verifikasi',
      verification_button: 'Lanjutkan',
      verification_error_message: 'Kode Verifikasi Diperlukan.',
    },
  },
  {
    name: 'Italiano',
    code: 'it-IT',
    eligibility_prompt_text: {
      heading: "Verifica l'idoneità all'assicurazione",
      subheading: 'Richiede 1 minuto',
      privacy_notice_heading:
        "Le tue informazioni sono utilizzate solo per l'idoneità",
      privacy_notice_body: 'Non memorizziamo né condividiamo i tuoi dati',
      question: 'Iniziare?',
      button_no: 'No',
      button_yes: 'Sì',
      verification_message: 'Inserisci il codice di verifica',
      verification_button: 'Continua',
      verification_error_message: 'Il codice di verifica è obbligatorio.',
    },
  },
  {
    name: '日本語',
    code: 'ja-JP',
    eligibility_prompt_text: {
      heading: '保険適格性を確認',
      subheading: '1分で完了',
      privacy_notice_heading: 'あなたの情報は適格性のためにのみ使用されます',
      privacy_notice_body: 'データは保存も共有もしません',
      question: '開始しますか？',
      button_no: 'いいえ',
      button_yes: 'はい',
      verification_message: '認証コードを入力してください',
      verification_button: '続行',
      verification_error_message: '認証コードは必須です。',
    },
  },
  {
    name: 'Türkçe',
    code: 'tr-TR',
    eligibility_prompt_text: {
      heading: 'Sigorta Uygunluğunu Kontrol Et',
      subheading: '1 dakika sürer',
      privacy_notice_heading: 'Bilgileriniz sadece uygunluk için kullanılır',
      privacy_notice_body: 'Verilerinizi saklamıyor veya paylaşmıyoruz',
      question: 'Başla?',
      button_no: 'Hayır',
      button_yes: 'Evet',
      verification_message: 'Doğrulama Kodunu Girin',
      verification_button: 'Devam',
      verification_error_message: 'Doğrulama Kodu Gereklidir.',
    },
  },
  {
    name: 'Tiếng Việt',
    code: 'vi-VN',
    eligibility_prompt_text: {
      heading: 'Kiểm tra tính đủ điều kiện bảo hiểm',
      subheading: 'Mất 1 phút',
      privacy_notice_heading:
        'Thông tin của bạn chỉ được sử dụng cho tính đủ điều kiện',
      privacy_notice_body: 'Chúng tôi không lưu hoặc chia sẻ dữ liệu của bạn',
      question: 'Bắt đầu?',
      button_no: 'Không',
      button_yes: 'Có',
      verification_message: 'Nhập mã xác nhận',
      verification_button: 'Tiếp tục',
      verification_error_message: 'Yêu cầu mã xác nhận.',
    },
  },
  {
    name: 'বাংলা',
    code: 'bn-IN',
    eligibility_prompt_text: {
      heading: 'বীমা যোগ্যতা পরীক্ষা করুন',
      subheading: '১ মিনিট সময় লাগে',
      privacy_notice_heading: 'আপনার তথ্য শুধুমাত্র যোগ্যতার জন্য ব্যবহৃত হয়',
      privacy_notice_body: 'আমরা আপনার ডেটা সংরক্ষণ বা শেয়ার করি না',
      question: 'শুরু করবেন?',
      button_no: 'না',
      button_yes: 'হ্যাঁ',
      verification_message: 'ভেরিফিকেশন কোড লিখুন',
      verification_button: 'চালিয়ে যান',
      verification_error_message: 'ভেরিফিকেশন কোড প্রয়োজন।',
    },
  },
  {
    name: 'ગુજરાતી',
    code: 'gu-IN',
    eligibility_prompt_text: {
      heading: 'વીમા પાત્રતા ચકાસો',
      subheading: '1 મિનિટ લાગે છે',
      privacy_notice_heading: 'તમારી માહિતી માત્ર પાત્રતાના માટે ઉપયોગ થાય છે',
      privacy_notice_body: 'અમે તમારો ડેટા સંગ્રહિત કે શેર કરતા નથી',
      question: 'શરૂ કરવું?',
      button_no: 'ના',
      button_yes: 'હા',
      verification_message: 'સત્યાપન કોડ દાખલ કરો',
      verification_button: 'ચાલુ રાખો',
      verification_error_message: 'સત્યાપન કોડ જરૂરી છે.',
    },
  },
  {
    name: 'ಕನ್ನಡ',
    code: 'kn-IN',
    eligibility_prompt_text: {
      heading: 'ವಿಮಾ ಅರ್ಹತೆ ಪರಿಶೀಲಿಸಿ',
      subheading: '1 ನಿಮಿಷ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ',
      privacy_notice_heading: 'ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ಅರ್ಹತೆಗಾಗಿ ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ',
      privacy_notice_body:
        'ನಾವು ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಸಂಗ್ರಹಿಸುವುದಿಲ್ಲ ಅಥವಾ ಹಂಚಿಕೊಳ್ಳುವುದಿಲ್ಲ',
      question: 'ಪ್ರಾರಂಭಿಸಬೇಕೇ?',
      button_no: 'ಇಲ್ಲ',
      button_yes: 'ಹೌದು',
      verification_message: 'ತಪಾಸಣಾ ಕೋಡ್ ನಮೂದಿಸಿ',
      verification_button: 'ಮುಂದುವರೆಸಿ',
      verification_error_message: 'ತಪಾಸಣಾ ಕೋಡ್ ಅಗತ್ಯವಿದೆ.',
    },
  },
  {
    name: 'മലയാളം',
    code: 'ml-IN',
    eligibility_prompt_text: {
      heading: 'ഇൻഷുറൻസ് യോഗ്യത പരിശോധിക്കുക',
      subheading: '1 മിനിറ്റ് വേണ്ടിവരും',
      privacy_notice_heading:
        'നിങ്ങളുടെ വിവരങ്ങൾ യോഗ്യതയ്ക്ക് മാത്രമേ ഉപയോഗിക്കൂ',
      privacy_notice_body:
        'ഞങ്ങൾ നിങ്ങളുടെ ഡാറ്റ സംഭരിക്കുകയോ പങ്കുവെക്കുകയോ ചെയ്യില്ല',
      question: 'തുടങ്ങാൻ?',
      button_no: 'ഇല്ല',
      button_yes: 'അവശ്യമാണ്',
      verification_message: 'പരിശോധന കോഡ് നൽകുക',
      verification_button: 'തുടരുക',
      verification_error_message: 'പരിശോധന കോഡ് ആവശ്യമാണ്.',
    },
  },
  {
    name: 'मराठी',
    code: 'mr-IN',
    eligibility_prompt_text: {
      heading: 'विमा पात्रता तपासा',
      subheading: '1 मिनिट लागतो',
      privacy_notice_heading: 'आपली माहिती फक्त पात्रतेसाठी वापरली जाते',
      privacy_notice_body: 'आम्ही तुमची माहिती जपत नाही किंवा शेअर करत नाही',
      question: 'सुरू करायचे?',
      button_no: 'नाही',
      button_yes: 'होय',
      verification_message: 'तपासणी कोड प्रविष्ट करा',
      verification_button: 'सुरू ठेवा',
      verification_error_message: 'तपासणी कोड आवश्यक आहे.',
    },
  },
  {
    name: 'தமிழ்',
    code: 'ta-IN',
    eligibility_prompt_text: {
      heading: 'காப்பீட்டு தகுதியைச் சரிபார்க்கவும்',
      subheading: '1 நிமிடம் ஆகும்',
      privacy_notice_heading:
        'உங்கள் தகவல் தகுதிக்காக மட்டுமே பயன்படுத்தப்படுகிறது',
      privacy_notice_body:
        'நாங்கள் உங்கள் தரவை சேமிக்கவோ பகிரவோ செய்ய மாட்டோம்',
      question: 'தொடக்கம்?',
      button_no: 'இல்லை',
      button_yes: 'ஆம்',
      verification_message: 'சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்',
      verification_button: 'தொடரவும்',
      verification_error_message: 'சரிபார்ப்புக் குறியீடு தேவையானது.',
    },
  },
  {
    name: 'తెలుగు',
    code: 'te-IN',
    eligibility_prompt_text: {
      heading: 'ఇన్సూరెన్స్ అర్హతను తనిఖీ చేయండి',
      subheading: '1 నిమిషం తీసుకుంటుంది',
      privacy_notice_heading: 'మీ సమాచారం అర్హత కోసం మాత్రమే ఉపయోగించబడుతుంది',
      privacy_notice_body: 'మేము మీ డేటాను నిల్వ చేయము లేదా పంచుకోము',
      question: 'ప్రారంభించాలా?',
      button_no: 'కాదు',
      button_yes: 'అవును',
      verification_message: 'తనిఖీ కోడ్ ను నమోదు చేయండి',
      verification_button: 'కొనసాగించండి',
      verification_error_message: 'తనిఖీ కోడ్ అవసరం.',
    },
  },
  {
    name: 'Nederlands',
    code: 'nl-NL',
    eligibility_prompt_text: {
      heading: 'Controleer verzekeringsgeschiktheid',
      subheading: 'Duur: 1 minuut',
      privacy_notice_heading:
        'Uw informatie wordt alleen gebruikt voor geschiktheid',
      privacy_notice_body: 'We slaan uw gegevens niet op of delen ze niet',
      question: 'Beginnen?',
      button_no: 'Nee',
      button_yes: 'Ja',
      verification_message: 'Voer de verificatiecode in',
      verification_button: 'Doorgaan',
      verification_error_message: 'Verificatiecode is verplicht.',
    },
  },
  {
    name: '한국어',
    code: 'ko-KR',
    eligibility_prompt_text: {
      heading: '보험 적격성 확인',
      subheading: '1분 소요',
      privacy_notice_heading: '귀하의 정보는 적격성에만 사용됩니다',
      privacy_notice_body: '데이터를 저장하거나 공유하지 않습니다',
      question: '시작하시겠습니까?',
      button_no: '아니요',
      button_yes: '예',
      verification_message: '인증 코드 입력',
      verification_button: '계속',
      verification_error_message: '인증 코드는 필수입니다.',
    },
  },
  {
    name: '官话',
    code: 'cmn-CN',
    eligibility_prompt_text: {
      heading: '检查保险资格',
      subheading: '需要1分钟',
      privacy_notice_heading: '您的信息仅用于资格审核',
      privacy_notice_body: '我们不存储或分享您的数据',
      question: '开始？',
      button_no: '否',
      button_yes: '是',
      verification_message: '输入验证码',
      verification_button: '继续',
      verification_error_message: '需要验证码。',
    },
  },
  {
    name: 'Polski',
    code: 'pl-PL',
    eligibility_prompt_text: {
      heading: 'Sprawdź uprawnienia do ubezpieczenia',
      subheading: 'Zajmuje 1 minutę',
      privacy_notice_heading:
        'Twoje informacje są używane tylko do celów uprawnienia',
      privacy_notice_body:
        'Nie przechowujemy ani nie udostępniamy Twoich danych',
      question: 'Zacząć?',
      button_no: 'Nie',
      button_yes: 'Tak',
      verification_message: 'Wprowadź kod weryfikacyjny',
      verification_button: 'Kontynuuj',
      verification_error_message: 'Kod weryfikacyjny jest wymagany.',
    },
  },
  {
    name: 'Русский',
    code: 'ru-RU',
    eligibility_prompt_text: {
      heading: 'Проверить право на страхование',
      subheading: 'Занимает 1 минуту',
      privacy_notice_heading:
        'Ваша информация используется только для проверки права',
      privacy_notice_body: 'Мы не сохраняем и не передаем ваши данные',
      question: 'Начать?',
      button_no: 'Нет',
      button_yes: 'Да',
      verification_message: 'Введите код подтверждения',
      verification_button: 'Продолжить',
      verification_error_message: 'Требуется код подтверждения.',
    },
  },
  {
    name: 'Kiswahili',
    code: 'sw-KE',
    eligibility_prompt_text: {
      heading: 'Angalia Uhalali wa Bima',
      subheading: 'Inachukua dakika 1',
      privacy_notice_heading: 'Taarifa zako zinatumika tu kwa uhalali',
      privacy_notice_body: 'Hatuhifadhi au kushiriki data yako',
      question: 'Anza?',
      button_no: 'Hapana',
      button_yes: 'Ndiyo',
      verification_message: 'Ingiza Nambari ya Uhakiki',
      verification_button: 'Endelea',
      verification_error_message: 'Nambari ya Uhakiki Inahitajika.',
    },
  },
  {
    name: 'ไทย',
    code: 'th-TH',
    eligibility_prompt_text: {
      heading: 'ตรวจสอบคุณสมบัติประกันภัย',
      subheading: 'ใช้เวลา 1 นาที',
      privacy_notice_heading: 'ข้อมูลของคุณใช้เฉพาะเพื่อการตรวจสอบคุณสมบัติ',
      privacy_notice_body: 'เราไม่เก็บหรือแบ่งปันข้อมูลของคุณ',
      question: 'เริ่มต้น?',
      button_no: 'ไม่',
      button_yes: 'ใช่',
      verification_message: 'กรุณาใส่รหัสยืนยัน',
      verification_button: 'ดำเนินการต่อ',
      verification_error_message: 'ต้องใส่รหัสยืนยัน',
    },
  },
  {
    name: 'اردو',
    code: 'ur-IN',
    eligibility_prompt_text: {
      heading: 'انشورنس اہلیت چیک کریں',
      subheading: '1 منٹ لگتا ہے',
      privacy_notice_heading: 'آپ کی معلومات صرف اہلیت کے لیے استعمال ہوتی ہے',
      privacy_notice_body: 'ہم آپ کا ڈیٹا ذخیرہ یا شیئر نہیں کرتے',
      question: 'شروع کریں؟',
      button_no: 'نہیں',
      button_yes: 'ہاں',
      verification_message: 'تصدیقی کوڈ درج کریں',
      verification_button: 'جاری رکھیں',
      verification_error_message: 'تصدیقی کوڈ ضروری ہے۔',
    },
  },
  {
    name: 'Українська',
    code: 'uk-UA',
    eligibility_prompt_text: {
      heading: 'Перевірити право на страхування',
      subheading: 'Займає 1 хвилину',
      privacy_notice_heading:
        'Ваша інформація використовується лише для перевірки права',
      privacy_notice_body: 'Ми не зберігаємо і не поширюємо ваші дані',
      question: 'Почати?',
      button_no: 'Ні',
      button_yes: 'Так',
      verification_message: 'Введіть код підтвердження',
      verification_button: 'Продовжити',
      verification_error_message: 'Потрібен код підтвердження.',
    },
  },
]
